module.exports = __webpack_public_path__ + "static/discovery-2-td5-eezi-awn-roof-tent-86df65f38362321677b601e0db804e1f.jpg";